function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgPlans2 = function SvgPlans2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 162 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10248_64161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3672 47.3203C89.1783 48.2543 90.5548 48.4264 91.5625 47.7136C93.5289 46.3125 96.0852 48.4264 95.0775 50.5894L89.1292 57.398H79.6168L73.6193 50.5157C72.6115 48.3281 75.1679 46.2142 77.1342 47.6153L77.3063 47.7382C78.314 48.451 79.6905 48.2543 80.4771 47.3203L82.6155 44.764C83.5495 43.6333 85.2947 43.6333 86.2287 44.764L88.3672 47.3203ZM55.332 91.1704C55.332 75.0952 68.3593 62.0679 84.4345 62.0679C100.51 62.0679 113.537 75.0952 113.512 91.1704C113.512 103.042 103.877 112.678 92.005 112.678H76.8393C64.9673 112.678 55.332 103.042 55.332 91.1704Z",
    fill: "#2C4BD3"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1387 85.5236H84.3108C87.9977 85.6219 90.9474 88.6206 90.9474 92.3076C90.9474 95.4539 88.8089 98.0839 85.9085 98.8705V101.623C85.9085 102.607 85.1219 103.393 84.1387 103.393C83.1555 103.393 82.369 102.607 82.369 101.623V98.8705C79.4685 98.0839 77.3301 95.4539 77.3301 92.3076C77.3301 91.3244 78.1166 90.5379 79.0998 90.5379C80.083 90.5379 80.8696 91.3244 80.8696 92.3076C80.8696 94.1265 82.3198 95.5768 84.1142 95.5768C85.9085 95.5768 87.3832 94.102 87.3832 92.3076C87.3832 90.5133 85.9085 89.0385 84.1142 89.0385H83.9421C80.2797 88.9402 77.3301 85.9414 77.3301 82.2544C77.3301 79.1082 79.4685 76.4782 82.369 75.6916V72.9387C82.369 71.9555 83.1555 71.1689 84.1387 71.1689C85.1219 71.1689 85.9085 71.9555 85.9085 72.9387V75.6916C88.8089 76.4782 90.9474 79.1082 90.9474 82.2544C90.9474 83.2376 90.1608 84.0242 89.1776 84.0242C88.1944 84.0242 87.4079 83.2376 87.4079 82.2544C87.4079 80.4601 85.9331 78.9853 84.1387 78.9853C82.3444 78.9853 80.8696 80.4601 80.8696 82.2544C80.8696 84.0488 82.3444 85.5236 84.1387 85.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0584 57.3032H88.5139C90.0133 57.3032 91.2422 58.5322 91.2422 60.0316C91.2422 61.531 90.0133 62.7599 88.5139 62.7599H80.0584C78.5591 62.7599 77.3301 61.531 77.3301 60.0316C77.3301 58.5322 78.5591 57.3032 80.0584 57.3032Z",
    fill: "#00278A"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10248_64161",
    x: 0.520572,
    y: 0.516014,
    width: 160.98,
    height: 171.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.41146,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360628 0 0 0 0 0.468474 0 0 0 0 1 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10248_64161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10248_64161",
    result: "shape"
  }))));
};
export default SvgPlans2;